import { IntlShape } from "react-intl";
import { localizeInterval } from "../parameters";

export default (chordType: string, intl: IntlShape) => {
    const { locale } = intl;
    let type = localizeInterval(chordType.slice(0, 1).replace("D", "N").replace("m", "k"), locale);
    const loc = chordType[1];
    let sup = loc;
    let sub = "";
    let sub2 = "";
    if (loc === "4") {
        sup = "6";
        sub = "4";
    }
    if (loc === "5") {
        sup = "6";
        sub = "5";
    }
    if (loc === "3") {
        sup = "4";
        sub = "3";
    }
    if (loc === "2") {
        sup = "2";
    }

    if (locale === "hu") {
        type = type.replace("N", "D").replace("k", "m").replace("s", "sz");
    } else if (locale.indexOf("en") === 0) {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "D7").replace("d", "d7");
            if (loc === "7") {
                sup = "r";
            }
        }
        if (loc === "a") {
            sup = "r";
        } else if (loc === "6" || loc === "5") {
            sup = "1st";
        } else if (loc === "4" || loc === "3") {
            sup = "2nd";
        } else if (loc === "2") {
            sup = "3rd";
        }
        sub = "";
    } else {
        if (loc === "a") {
            sup = "5";
        }
    }
    if (locale === "lt") {
        type = type.replace(/^d./, "M.").replace(".", "");
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "D");
            if (loc === "7") {
                sup = "";
            }
        }
        if (loc === "5") {
            sup = "5";
            sub2 = "6";
        } else if (loc === "7") {
            sup = "7";
        } else if (loc === "3") {
            sup = "3";
            sub2 = "4";
        } else if (loc === "2") {
            sup = "2";
        }
        if (sub === "4") {
            sup = "";
            sub2 = "6";
        } else {
            sub = sup;
            sup = "";
        }
    }
    if (locale === "el") {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "Dom");
        }
        type = type.replace("M", "Μείζ.").replace("μ", "Ελάσ.").replace("E", "Ελατ.").replace("A", "Αυξ.");
        if (sup === "5") {
            sup = "";
        }
    }
    if (locale === "nl") {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("G", "D");
        }
        if (sup === "5") {
            sup = "";
        }
    }
    if (locale === "et") {
        type = type.replace("s", "M").replace("v", "m").replace("<", "<kk").replace(">", ">kk");
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "D");
        }
        // if (sub === "4") {
        //     sup = "";
        //     sub = "6";
        //     sub2 = "4";
        // } if (loc === "7") {
        //     sup = "";
        //     sub = "7";
        // } else if (loc === "5") {
        //     sup = "";
        //     sub = "6";
        //     sub2 = "5";
        // } else if (loc === "3") {
        //     sup = "";
        //     sub = "4";
        //     sub2 = "3";
        // } else {
        //     sub = sup;
        //     sup = "";
        // }
        if (sup === "5") {
            sup = "";
        }
    }
    if (locale === "it") {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "D");
        }
        if (sup === "5") {
            sup = "";
        }
    }
    if (locale === "es" || locale === "ca") {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("M", "D");
        }
        if (sup === "5") {
            sup = "";
        }
        type = type.replace("A", "aug");
    }
    if (locale === "hr") {
        type = type.replace("V", "D");
        if (sup === "5") {
            sup = "";
        }
    }
    if (locale === "pl") {
        if (loc === "5" || loc === "3" || loc === "2" || loc === "7") {
            type = type.replace("N", "D");
        }
        type = type.replace("N", "+").replace("k", "o").replace("B", "<").replace("s", ">");
        if (loc === "5") {
            sup = "6";
            sub = "5";
        } else if (sup === "5") {
            sup = "";
        } else if (sub === "4") {
            sup = "";
            sub = "5";
        } else if (sup === "6") {
            sup = "";
            sub = "3";
        }
    }
    return {
        type,
        sup,
        sub,
        sub2,
    };
};
